<template>
  <div class="ProductShippingInfo-outer"
   :class="{'zeborne': isZeborne}">
    <div class="ProductShippingInfo">
      <div class="ProductShippingInfo-select" v-if="productShippingInfo.existAlso.length > 0">
        <ProductExistAlso :productChoice="productShippingInfo.existAlso"></ProductExistAlso>
      </div>
      <div class="ProductShippingInfo-container">
        <ProductPrice
          :specialPrice="productShippingInfo.prices.finalPrice[productCurrentTva]"
          :originalPrice="productShippingInfo.prices.price[productCurrentTva]"
          :available="productShippingInfo.available"
        ></ProductPrice>
      </div>
    </div>
  </div>
</template>

<script>
import ProductExistAlso from "@/includes/Product/ProductExistAlso/ProductExistAlso.vue";
import ProductPrice from "@/includes/Product/ProductPrice/ProductPrice.vue";
import { mapGetters } from "vuex";
import EventBus from "@/event-bus";

import "@/includes/Product/ProductShippingInfo/ProductShippingInfo.scss";

export default {
  name: "ProductShippingInfo",

  components: {
    ProductExistAlso,
    ProductPrice,
  },

  computed: {
    ...mapGetters({ productShippingInfo: "getProductShippingInfo" }),
    ...mapGetters({ productShippingMethods: "getProductShippingMethods" }),
    ...mapGetters({ productBillInfo: "getProductBillInfo" }),
    ...mapGetters({ productCurrentTva: "getProductTVAForCurrentDelivery" }),
    ...mapGetters({ isZeborne: "isZeborne" }),
    ...mapGetters({ isLead: "isLead" }),
  },

  methods: {
    scrollTo (event) {
      EventBus.$emit("action-scroll", event);
    },
  },
};
</script>
